import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { EmailOutlined } from "@mui/icons-material";
import { toast } from "react-toastify";
import Loading from "../../../components/Loading";
import withAuthenticationRequired from "../../../components/ProtectedRoutes/withAuthenticationRequired";
import useCompra from "../../../components/perfil/Compras/VerCompra/useCompra";
import BarraCompra from "../../../components/compras/BarraCompra";
import ItemsCompra from "../../../components/compras/ItemsCompra";
import { api } from "../../../services/api";

const PRIMARIO = "#5656FF";

const DetalleVenta = () => {
  const { id, idventa } = useParams();
  const history = useHistory();
  const { compra, loading, unauthorized } = useCompra(idventa);
  const [confirmando, setConfirmando] = useState(false);
  const [reenviando, setReenviando] = useState(false);

  if (unauthorized) return null;
  if (loading) return <Loading />;

  const reenviar = async () => {
    setReenviando(true);
    try {
      const respuesta = await api.email.reSend(compra.id);
      if (respuesta.status !== "success") throw new Error(respuesta.message);
      toast.success(respuesta.message || "Mail reenviado.");
      setConfirmando(false);
    } catch (error) {
      toast.error(error.message || "No se pudo reenviar el mail.");
    } finally {
      setReenviando(false);
    }
  };

  return (
    <div className="container-fluid container-sm mx-auto mt-1 mb-5">
      <BarraCompra
        compraId={compra?.id}
        etiqueta="Comprador"
        valor={compra?.email}
        onVolver={() => history.push(`/eventos/${id}/ventas`)}
      >
        <Button
          variant="contained"
          size="small"
          startIcon={<EmailOutlined />}
          onClick={() => setConfirmando(true)}
          sx={{ bgcolor: PRIMARIO, textTransform: "none", "&:hover": { bgcolor: "#4545dd" } }}
        >
          Reenviar email
        </Button>
      </BarraCompra>

      <ItemsCompra compra={compra} />

      <Dialog open={confirmando} onClose={() => !reenviando && setConfirmando(false)}>
        <DialogTitle sx={{ fontFamily: "Bricolage Grotesque", fontSize: 18 }}>¿Reenviar las entradas?</DialogTitle>
        <DialogContent>
          <Typography>Se envían de nuevo a <strong>{compra?.email}</strong>.</Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setConfirmando(false)} disabled={reenviando} sx={{ textTransform: "none", color: "#374151" }}>
            Cancelar
          </Button>
          <Button variant="contained" onClick={reenviar} disabled={reenviando} sx={{ textTransform: "none", bgcolor: PRIMARIO }}>
            {reenviando ? <CircularProgress size={18} sx={{ color: "white" }} /> : "Reenviar"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withAuthenticationRequired(DetalleVenta, {
  onRedirecting: () => <Loading />,
});
